/* global ga Turbolinks */
/* eslint-disable no-console */

export { trackPageView }

let clientId = 'not found'

function load() {
  window.ga = window.ga || function(){
    (ga.q = ga.q||[]).push(arguments)
  }
  ga.l=+new Date
  ga('create', window.googleAnalyticsId, 'auto')
  ga('create', window.aggregateGaId, 'auto', 'clientTracker')

  // Anonymizes IP Addresses
  ga('set', 'anonymizeIp', true)
  ga('clientTracker.set', 'anonymizeIp', true)

  if (window.experimentId) { ga('set', 'expId', window.experimentId) }
  if (window.chosenVariation) { ga('set', 'expVar', window.chosenVariation) }

  // If Turbolinks is supported, set up a callback to track pageviews on
  // page:change.  If it isn't supported, just track the pageview now.
  // Turbolinks supports all major browsers, if Turbolinks.supported
  if ((typeof Turbolinks !== 'undefined') && Turbolinks.supported) {
    document.addEventListener('turbolinks:load',function(){
      trackPageView(location.pathname)
    }, true)
  } else {
    // trackPageView(location.pathname) // Remove this if no issues with analytics are detected
  }
}

function trackPageView(pathName) {
  var el = document.getElementById('gaPathOverride')
  var path = pathName
  if(el) {
    path = el.dataset.url
  }
  if (window.location.href.includes('cart')) {
    let referrer = document.cookie.split(';').find(element => element.includes('referrer'))
    if (referrer) {
      ga('set', 'referrer', referrer)
    }
  }

  if (!window.googleAnalyticsId) { return }
  ga(function(tracker) {
    clientId = tracker.get('clientId')
    ga('send', 'pageview', path, {'dimension1': `${clientId}`})
    ga('clientTracker.send', 'pageview',
      path, {'dimension1': `${clientId}`})
    $('.ga-id').val(clientId)
  })
  ga('send', 'timing', 'Page Load')
  ga('clientTracker.send', 'timing', 'Page Load')
}

if (window.googleAnalyticsId) {
  load()

  $(document).on('click', '[data-ga-event-category]', function() {
    const gaHash = {
      eventCategory: $(this).data('gaEventCategory'),
      eventAction: $(this).data('gaEventAction'),
      eventLabel: $(this).data('gaEventLabel'),
      transport: 'beacon'
    }

    ga('send', 'event', gaHash)
    ga('clientTracker.send', 'event', gaHash)
  })
}
